import { render, staticRenderFns } from "./LeadList.vue?vue&type=template&id=1c45e0af&"
import script from "./LeadList.vue?vue&type=script&lang=js&"
export * from "./LeadList.vue?vue&type=script&lang=js&"
import style0 from "./LeadList.vue?vue&type=style&index=0&id=1c45e0af&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c45e0af')) {
      api.createRecord('1c45e0af', component.options)
    } else {
      api.reload('1c45e0af', component.options)
    }
    module.hot.accept("./LeadList.vue?vue&type=template&id=1c45e0af&", function () {
      api.rerender('1c45e0af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/leads/LeadList.vue"
export default component.exports